export function assignIcons(itemsArray, iconsArray) {
  return itemsArray.map((item, index) => {
    return {
      ...item,
      icon: iconsArray[index],
    };
  });
}
